import { Box, Checkbox } from '@nimbus-ds/components';
import { UpdateContentPagesRequestDto } from '@tiendanube/common';
import {
  CancelAndSaveButtons,
  CancelAndSaveButtonsProps,
} from 'commons/components';
import useTranslationOnline from 'domains/Online/useTranslationOnline';

interface FormFooterProps extends CancelAndSaveButtonsProps {
  values: UpdateContentPagesRequestDto;
  onShowInStoreChange?: (e: boolean) => void;
}

export default function FormFooter({ ...props }: FormFooterProps) {
  const t = useTranslationOnline('contentPages.formPage');

  const { values, onShowInStoreChange, ...buttonsProps } = props;

  const handleOnChangeShowInStore = ({ target: { checked: value } }) => {
    onShowInStoreChange?.(value);
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      paddingLeft="0-5"
      gap="10"
    >
      <Checkbox
        onChange={handleOnChangeShowInStore}
        name="showInStore"
        label={t('showInStore')}
        checked={!!values.showInStore}
      />
      <CancelAndSaveButtons {...buttonsProps} />
    </Box>
  );
}
